<template lang="pug">
.slider(
  @mouseleave="play",
  @mouseenter="pause")
  .swiper-container
    .swiper-wrapper
      .swiper-slide(
        v-for="(item, index) in list",
        :key="index"
        @click="$router.push(`/portfolio?page=1&cat=${item.categories}&id=${item.id}`)")
        img.img(:src="item.image")
        .logo
          img(:src="item.logo")
          .desc {{lang === 'zh' ? item.slogan : item.slogan_en}}
</template>

<script>
const Slider = {
  props: [],
  data () {
    return {
      swiper: null,
      hoverd: 0,
      list: []
    }
  },
  mounted () {
    window.$http.get(window.hostName + 'wp-json/wp/v2/portfolio?tags=51').then(res => {
      this.list = res.data.map(item => {
        return {
          id: item.id,
          logo: item.logo.guid,
          image: item.image.guid,
          title: item.title.rendered,
          title_en: item.title_en || item.title.rendered,
          slogan: item.slogan,
          slogan_en: item.slogan_en || item.slogan,
          categories: item.categories[0],
          tags: item.tags[0]
        }
      })
      this.$nextTick(function () {
        if (document.body.clientWidth >= 720) {
          this.swiper = new window.Swiper('.swiper-container', {
            slidesPerView: 5,
            spaceBetween: 0,
            loop: true,
            autoplay: true,
            speed: 2000
          })
        } else {
          this.swiper = new window.Swiper('.swiper-container', {
            slidesPerView: 2,
            slidesPerColumn: 3,
            spaceBetween: 0,
            autoplay: true,
            speed: 5000
          })
        }
      })
    })
  },
  components: {
  },
  computed: {
    lang () {
      return localStorage.lang
    }
  },
  methods: {
    pause () {
      this.swiper.stopAutoplay()
    },
    play () {
      this.swiper.startAutoplay()
    }
  }
}
export default Slider
</script>

<style scoped lang="stylus">
@media (min-width: 720px) {
  .slider{
    width: 1920px;
    overflow: hidden;
    cursor: pointer;
    .swiper-slide:hover{
      .img{
        opacity: 0
      }
    }
    .swiper-slide{
      position: relative;
      &:hover{
        .logo .desc{
          bottom: 0;
        }
      }
      img{
        width: 100%;
        position: relative;
        transition: all .5s;
        display: block;
      }
      .logo{
        overflow: hidden;
        position: absolute;
        top: 0;
        z-index: -1;
        height: 100%;
        img{
          width: 100%;
          display: inline-block;
          vertical-align: bottom;
          transition: all .5s;
          opacity: 1;
        }
        .desc{
          font-size: 18px;
          width: 100%;
          padding: 0 15%;
          color: #fff;
          height: 54px;
          line-height: 27px;
          text-align: center;
          position: absolute;
          font-weight: bold;
          bottom: -28px;
          transition: all .5s;
          background: url(../assets/bg_blue.png);
        }
      }
    }
  }
  .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear;    /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }
}
@media (max-width: 720px) {
  .slider{
    margin-top: 200px;
    width: 1920px;
    overflow: hidden;
    cursor: pointer;
    .swiper-slide{
      position: relative;
      img{
        width: 100%;
        height: 100%;
        vertical-align: bottom;
      }
      .logo{
        display: none;
      }
    }
  }
  .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear;    /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// slider.vue?2974a40e